// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-template-marketplace.vert-card-product.ant-card > .ant-card-body .vert-card-content .vert-card-content-inner .vert-card-product-infos .vert-card-product-infos-inner .vert-card-product-vendor .txt-paragraph {
  height: 45px;
  overflow: hidden;
  display: block;
}
@media screen and (max-width: 768px) {
  .vert-template-marketplace.vert-card-product.ant-card > .ant-card-body .vert-card-content .vert-card-content-inner .vert-card-product-infos .vert-card-product-infos-inner .vert-card-product-vendor .txt-paragraph {
    height: 39px !important;
  }
}
.VertCardItemSkeleton {
  width: 100% !important;
}
.VertCardItemSkeleton span {
  min-height: 400px;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Card/cardStyle.less"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,gBAAA;EACA,cAAA;AACJ;AAAI;EAAA;IACI,uBAAA;EAGN;AACF;AAAA;EACI,sBAAA;AAEJ;AADI;EACI,iBAAA;AAGR","sourcesContent":[".vert-template-marketplace.vert-card-product.ant-card > .ant-card-body .vert-card-content .vert-card-content-inner .vert-card-product-infos .vert-card-product-infos-inner .vert-card-product-vendor .txt-paragraph {\n    height: 45px;\n    overflow: hidden;\n    display: block;\n    @media screen and (max-width: 768px) {\n        height: 39px !important;\n    }\n}\n\n.VertCardItemSkeleton {\n    width: 100% !important;\n    & span {\n        min-height: 400px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
